<template>
  <div
    :class="{
      'anonymous-container': isAnonymousBidder && auction.status === ACTIVE_TENDERING_STATUS,
    }"
  >
    <SuccessRegisterModalForInvitedUser
      v-if="isAnonymousBidder && isAnonymousBidderCreatedBid"
      :auction="auction"
    />
    <v-snackbar v-model="snackbar" :bottom="'bottom'" :timeout="5000" white>
      Widget code copied to clipboard
      <v-btn color="pink" text @click="snackbar = false"> Close </v-btn>
    </v-snackbar>
    <div v-if="auction" class="auc-info">
      <div
        v-if="
          !editAuction &&
          auction.status === ACTIVE_TENDERING_STATUS &&
          loginInfo.isLogged &&
          !Boolean($route.query.invitation_token)
        "
        @click.prevent="
          editAuction = true;
          copyAuction.title = auction.title;
          copyAuction.description = auction.description;
        "
        class="edit-auc"
      >
        <span id="edit">{{ auctionDetailTitleLabels.EDIT_ACTION }}</span>
        <v-icon color="teal" right>edit</v-icon>
      </div>
      <div
        v-if="
          editAuction &&
          auction.status !== COMPLETE_STATUS &&
          auction.status !== UNSUCCESSFUL_STATUS
        "
        class="edit-auc edit-auc-cancel-save"
      >
        <div @click.prevent="editAuction = false" class="edit-auc-cancel">
          <span>Cancel</span>
          <v-icon id="discard-edit-auc" color="red lighten-3" title="Discard" dark>close</v-icon>
        </div>
        &nbsp; &nbsp;
        <div @click.prevent="saveNewAucInfo()" class="edit-auc-save">
          <span>Save</span>
          <v-icon id="confirm-edit-auc" color="teal" title="Save" right>done</v-icon>
        </div>
      </div>
      <v-layout row wrap no-gutters>
        <v-flex sm12 xs12 md8>
          <div class="right-side">
            <p v-if="!editAuction" class="auc-title">
              <a
                class="auc-title"
                style="text-decoration: none"
                :href="auction.auctionUrl"
                v-if="auction && auction.auctionUrl"
              >
                {{ auction.title }}
              </a>
            </p>
            <p v-else>
              <input
                class="custom-input-edit"
                v-model="copyAuction.title"
                style="
                  font-size: 18px;
                  font-weight: 600;
                  color: #2e7f89;
                "
              />
            </p>
            <p style="font-size: 12px">
              <strong>{{ auctionDetailFieldLabelsWithColon.TYPE }} </strong>
              <span class="auc-type">{{ auctionType[auction.procurementMethodType] }}</span>
            </p>
            <p style="font-size: 12px">
              <strong>{{ auctionDetailFieldLabelsWithColon.STATUS }} </strong
              ><span class="auc-status" :style="{ background: getStatusColor(auction.status) }">{{
                auctionStatusByKey[auction.status]
              }}</span>
            </p>
            <p style="font-size: 12px" v-if="showAuctionStartDate">
              <strong>{{ auctionDetailFieldLabelsWithColon.DATE }} </strong>
              <span class="auc-type">{{
                auction.auctionPeriod.startDate | moment('DD/MM/YYYY HH:mm:ss')
              }}</span>
            </p>
            <p style="font-size: 12px" v-if="showAuctionEndDate">
              <strong>{{ auctionDetailFieldLabelsWithColon.AUCTION_ENDS }} </strong>
              <span class="auc-type">{{
                auction.auctionPeriod.endDate | moment('DD/MM/YYYY HH:mm:ss')
              }}</span>
            </p>
            <p style="font-size: 12px" v-if="showStartingPrice">
              <strong>{{ auctionDetailFieldLabelsWithColon.STARTING_PRICE }} </strong>
              <span class="auc-type" id="auction-value">{{
                formatCurrencyAmount(auction.value.amount, auction.value.currency)
              }}</span>
            </p>
            <p style="font-size: 12px" v-if="showMinimumBidStep">
              <strong>{{ auctionDetailFieldLabelsWithColon.MINIMUM_BID_STEP }} </strong>
              <span class="auc-type" id="auction-minimalstep">{{
                formatCurrencyAmount(auction.minimalStep.amount, auction.value.currency)
              }}</span>
            </p>
            <p style="font-size: 12px" v-if="showAntiSniping">
              <strong>{{ auctionDetailFieldLabelsWithColon.ANTI_SNIPING }} </strong>
              <span class="auc-type">{{ reverseContinuousAntiSnipingText }}</span>
            </p>
            <p style="font-size: 12px" v-if="showReservePrice">
              <strong>{{ auctionDetailFieldLabelsWithColon.RESERVE_PRICE }} </strong>
              <span class="auc-type">{{
                formatCurrencyAmount(
                  auction.reservePrice.amount,
                  auction.reservePrice.currency
                )
              }}</span>
            </p>
            <p style="font-size: 12px" v-if="showProxyBidding">
              <strong>{{ auctionDetailFieldLabelsWithColon.PROXY_BIDDING }} </strong>
              <span class="auc-type">Yes</span>
            </p>
            <p style="font-size: 12px" v-if="showSoldFor">
              <strong>{{ auctionDetailFieldLabelsWithColon.SOLD_FOR }} </strong>
              <span class="auc-type">{{
                formatCurrencyAmount(calculateWinner.value.amount, auction.value.currency)
              }}</span>
            </p>
            <p
              v-if="!editAuction"
              v-html="formattedTextareaValueForDiv"
              class="auc-discription"
            ></p>
            <p v-else style="width: 100%">
              <textarea
                class="custom-input-edit"
                cols="100%"
                rows="10"
                style="width: 100%; height: 100%"
                v-model="copyAuction.description"
              />
            </p>
          </div>
        </v-flex>
        <v-flex sm12 xs12 md4>
          <div class="mx-auto">
            <v-layout
              class="detail-auction__right-side pa-4"
              v-if="auction.tenderPeriod"
              pt-3
              no-gutters
            >
              <v-flex>
                <p
                  style="display: flex"
                  v-if="
                    auctionStartDateTimer !== 'Passed' && isTenderingOrAuctionStatus(auction.status)
                  "
                >
                  Time to Start (hh:mm:ss)
                </p>
                <h1 style="display: flex" v-if="auctionStartDateTimer !== 'Passed'">
                  {{ auctionStartDateTimer }}
                </h1>
                <p
                  v-if="auction.status === ACTIVE_TENDERING_STATUS"
                  style="display: flex; margin-right: 20px; text-align: left"
                >
                  Bidders Registration will be closed 10 minutes before the Auction Start
                </p>
                <RegisterBidderForm
                  v-if="auction.status === ACTIVE_TENDERING_STATUS"
                  :auction="auction"
                  @getDetailAuctionRequest="getAuctionDetail"
                />
                <p style="display: flex; margin-right: 20px; text-align: left" v-else>
                  Bidder Registration is Closed
                </p>
                <v-layout style="width: 100%" mt-3 row align-center no-gutters>
                  <div v-if="auction.auctionUrl">
                    <a :href="auction.auctionUrl" :title="auction.auctionUrl" target="_blank"
                      >Auction Link</a
                    >
                    &nbsp;
                    <v-tooltip bottom>
                      <template #activator="{ on }">
                        <img
                          @click="copyToClipboard(auction.auctionUrl)"
                          src="../assets/copy.png"
                          class="copy"
                          alt="Copy"
                          v-on="on"
                        />
                      </template>
                      <div>COPY</div>
                    </v-tooltip>
                  </div>
                </v-layout>
                <v-layout style="width: 100%" mt-3 row align-center no-gutters>
                  <div>
                    <a :title="auction.related_id" target="_blank">Auction ID</a> &nbsp;
                    <v-tooltip bottom>
                      <template #activator="{ on }">
                        <img
                          src="../assets/copy.png"
                          class="copy"
                          alt="Copy"
                          @click="copyToClipboard(auction.related_id)"
                          v-on="on"
                        />
                      </template>
                      <div>COPY</div>
                    </v-tooltip>
                  </div>
                </v-layout>
                <v-layout
                  v-if="auction.status === ACTIVE_TENDERING_STATUS && !isAnonymousBidder"
                  style="width: 100%"
                  mt-3
                  row
                  align-center
                  no-gutters
                >
                  <div v-if="invitationLink">
                    <a :href="invitationLink" :title="invitationLink" target="_blank"
                      >Invitation Link</a
                    >
                    &nbsp;
                    <v-tooltip bottom>
                      <template #activator="{ on }">
                        <img
                          @click="copyToClipboard(invitationLink)"
                          src="../assets/copy.png"
                          class="copy"
                          alt="Copy"
                          v-on="on"
                        />
                      </template>
                      <div>COPY</div>
                    </v-tooltip>
                  </div>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
    </div>
    <div>
      <TableOfItems
        v-if="auction.items"
        :auction="auction"
        :tableHeaders="tableHeaders"
      />
      <TableOfAuctionDocuments :auction="auction" />
      <TableOfBidders
        v-if="!isAnonymousBidder || (isAnonymousBidder && isAnonymousBidderCreatedBid)"
        :auction="auction"
        :isAnonymousBidder="isAnonymousBidder"
        :winner="calculateWinner"
        :lotWinners="lotWinners"
        @getDetailAuctionRequest="getAuctionDetail"
      />
      <v-dialog
        v-if="auction.related_id"
        v-model="dialogWidget"
        :width="zoomBlock"
        :fullscreen="$vuetify.breakpoint.xs"
      >
        <template #activator="{ on }">
          <v-btn v-on="on" class="widget" dark
            >Widget
            <v-icon right>ballot</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title> Widget </v-card-title>
          <div class="pa-4">
            <v-card-text
              style="
                box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
                  0 1px 5px 0 rgba(0, 0, 0, 0.12);
                margin: 0 auto;
              "
              :style="{
                backgroundColor: backgroundColorForWidget,
                width: '100%',
                maxWidth: '100%',
              }"
              class="pa-2 mb-2"
            >
              <h1
                class="ma-0 mb-2"
                style="font-size: 1.5rem"
                :style="{ color: headerTitleColor, fontWeight: 400 }"
                v-if="widgetRequest"
              >
                {{ widgetTitle ? widgetTitle : auctionDetailTitleLabels.WIDGET_COUNTDOWN }}
              </h1>
              <div class="d-flex justify-center">
                <div v-if="!widgetTitle" id="clockdiv">
                  <div v-if="countDown.day" :style="{ backgroundColor: backgroundForTiming }">
                    <span class="days" id="day">{{ countDown.day }}</span>
                    <div class="smalltext">Days</div>
                  </div>
                  <div v-if="countDown.hour" :style="{ backgroundColor: backgroundForTiming }">
                    <span class="hours" id="hour">{{ countDown.hour }}</span>
                    <div class="smalltext">Hours</div>
                  </div>
                  <div v-if="countDown.minute" :style="{ backgroundColor: backgroundForTiming }">
                    <span class="minutes" id="minute">{{ countDown.minute }}</span>
                    <div class="smalltext">Minutes</div>
                  </div>
                  <div v-if="countDown.second" :style="{ backgroundColor: backgroundForTiming }">
                    <span class="seconds" id="second">{{ countDown.second }}</span>
                    <div class="smalltext">Seconds</div>
                  </div>
                </div>
              </div>
              <p id="demo"></p>
              <p
                v-if="
                  auction &&
                  auction.status === COMPLETE_STATUS &&
                  calculateWinner &&
                  calculateWinner.value &&
                  auction.value &&
                  auction.value.currency
                "
                class="widget--amount"
              >
                Sold for:
                <strong>
                  {{ formatCurrencyAmount(calculateWinner.value.amount, auction.value.currency) }}
                </strong>
              </p>
              <p
                v-if="auction && auction.value && auction.value.amount"
                class="ma-0 my-2 text-center widget--amount"
              >
                Initial bid price:
                <strong>
                  {{ formatCurrencyAmount(auction.value.amount, auction.value.currency) }}
                </strong>
              </p>
              <a
                v-if="auction && auction.status === ACTIVE_TENDERING_STATUS"
                class="button d-inline-block text-center"
                :style="{ backgroundColor: buttonColor }"
                :href="invitationLink"
                id="register-bid"
                style="display: block"
                >Register to Bid</a
              >
            </v-card-text>

            <v-divider></v-divider>
            <WidgetCustomize />
            <v-card-actions>
              <v-btn color="grey lighten-2" v-clipboard:copy="copyClipboard" @success="onCopy"
                >Copy this widget &nbsp;<i class="material-icons">file_copy</i>
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="grey lighten-2" @click="closeWidgetDialog()"> Close </v-btn>
            </v-card-actions>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import utils from '@/utils/utils.js';
import TableOfBidders from '@/components/auctionDetailComponents/TableOfBidders.vue';
import RegisterBidderForm from '@/components/auctionDetailComponents/RegisterBidderForm.vue';
import TableOfItems from '@/components/auctionDetailComponents/TableOfItems.vue';
import TableOfAuctionDocuments from '@/components/auctionDetailComponents/TableOfAuctionDocuments.vue';
import AuctionsService from '@/services/AuctionsService';
import WidgetCustomize from '@/views/WidgetCustomize';
import SuccessRegisterModalForInvitedUser from '@/components/auctionDetailComponents/SuccessRegisterModalForInvitedUser.vue';
import { formatCurrencyAmount } from '@/utils/numberFormat';
import { required, email, minLength, minValue, maxValue } from 'vuelidate/lib/validators';
import axios from 'axios';
import _ from 'lodash';
import { mapActions, mapState } from 'vuex';
import {
  AUCTION_TYPE_LABELS,
  AUCTION_STATUS_LABELS,
  ACTIVE_TENDERING_STATUS,
  ACTIVE_AUCTION_STATUS,
  COMPLETE_STATUS,
  UNSUCCESSFUL_STATUS,
  ENGLISH_TYPE,
  ENGLISH_REVERSE_CONTINUOUS_TYPE,
  isReverseLikeType,
  isMultilotType,
  isTenderingOrAuctionStatus,
  AUCTION_DETAIL_TITLE_LABELS,
  AUCTION_DETAIL_FIELD_LABELS,
} from '@/constants/auction';
import { copyWithSnackbar } from '@/utils/clipboard';
import { getAuctionStatusClass, getAuctionStatusColor } from '@/utils/auctionStatusUi';

export default {
  data() {
    return {
      auctionType: {
        ...AUCTION_TYPE_LABELS,
      },
      auctionStatusByKey: {
        ...AUCTION_STATUS_LABELS,
      },
      auctionDetailTitleLabels: AUCTION_DETAIL_TITLE_LABELS,
      auctionDetailFieldLabels: AUCTION_DETAIL_FIELD_LABELS,
      ACTIVE_TENDERING_STATUS,
      COMPLETE_STATUS,
      UNSUCCESSFUL_STATUS,
      ENGLISH_REVERSE_CONTINUOUS_TYPE,
      editAuction: false,
      widgetTitle: '',
      timer: '',
      widgetRequest: false,
      snackbar: false,
      tenderStartDateInterval: false,
      tenderStartDateTimer: '',

      tenderEndDateInterval: false,
      tenderEndDateTimer: '',

      auctionStartDateInterval: false,
      auctionStartDateTimer: '',

      isSubscribersBidChanged: false,
      form: {
        name: '',
        email: '',
      },
      auction: {},
      copyAuction: {
        title: '',
        description: '',
      },
      dialog: false,
      countDown: {
        day: '',
        hour: '',
        minute: '',
        second: '',
        countdown: '',
      },
      dialogWidget: false,
      dialogUpdate: false,
      itemHeaders: [
        {
          text: 'Item',
          align: 'left',
          sortable: false,
          value: 'name',
        },
        { text: 'Description', value: 'description' },
        { text: 'Quantity', value: 'quantity' },
        { text: 'Unit(name:code:value)', value: 'unit' },
        { text: 'Address', value: 'address' },
        { text: 'Location', value: 'location' },
      ],
    };
  },
  filters: {
    filterDouble(value) {
      if (value < 0) {
        return '00';
      }
      if (value.toString().length <= 1) {
        return `0${value}`;
      }
      return value;
    },
  },
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  components: {
    TableOfBidders,
    RegisterBidderForm,
    TableOfItems,
    TableOfAuctionDocuments,
    WidgetCustomize,
    SuccessRegisterModalForInvitedUser,
  },
  watch: {
    dialogWidget(newValue) {
      if (newValue) {
        this.widgetApi(this.auction.related_id);
      } else {
        clearInterval(this.timer);
        this.timer = '';
      }
    },
  },
  computed: {
    ...mapState([
      'loginInfo',
      'isAnonymousBidderCreatedBid',
      'zoomBlock',
      'backgroundColorForWidget',
      'headerTitleColor',
      'backgroundForTiming',
      'buttonColor',
      'apiAtreus',
    ]),
    formattedTextareaValueForDiv() {
      if (this.auction && this.auction.description) {
        return this.auction.description.replace(/\r?\n/g, '<br>');
      } else {
        return '';
      }
    },
    isEnglishReverseContinuousAuction() {
      return (
        this.auction &&
        this.auction.procurementMethodType === ENGLISH_REVERSE_CONTINUOUS_TYPE
      );
    },
    showAuctionStartDate() {
      return (
        this.auction &&
        this.auction.auctionPeriod &&
        this.auction.auctionPeriod.startDate
      );
    },
    showAuctionEndDate() {
      return (
        this.isEnglishReverseContinuousAuction &&
        this.auction.auctionPeriod &&
        this.auction.auctionPeriod.endDate
      );
    },
    showStartingPrice() {
      return this.auction && this.auction.value && this.auction.value.amount;
    },
    showMinimumBidStep() {
      return this.auction && this.auction.minimalStep && this.auction.minimalStep.amount;
    },
    showAntiSniping() {
      return Boolean(this.reverseContinuousAntiSnipingText);
    },
    showReservePrice() {
      const { reservePrice } = this.auction || {};
      return reservePrice && reservePrice.amount;
    },
    showProxyBidding() {
      return this.auction && this.auction.proxyBidding === true;
    },
    showSoldFor() {
      return (
        this.calculateWinner && this.auction && this.auction.status === COMPLETE_STATUS
      );
    },
    calculateWinner() {
      if (isMultilotType(this.auction.procurementMethodType)) {
        // Multilot bids carry no top-level value.amount; winners are computed per lot.
        return null;
      }
      if (isReverseLikeType(this.auction.procurementMethodType)) {
        return _.minBy(this.auction.bids, 'value.amount');
      } else return _.maxBy(this.auction.bids, 'value.amount');
    },
    lotWinners() {
      if (
        !isMultilotType(this.auction.procurementMethodType) ||
        !Array.isArray(this.auction.lots)
      ) {
        return {};
      }
      const winners = {};
      this.auction.lots.forEach((lot) => {
        const bidsForLot = (this.auction.bids || []).filter(
          (bid) =>
            Array.isArray(bid.lotValues) &&
            bid.lotValues.some((lv) => lv.relatedLot === lot.id)
        );
        if (!bidsForLot.length) return;
        winners[lot.id] = _.minBy(bidsForLot, (bid) => {
          const lotValue = bid.lotValues.find((lv) => lv.relatedLot === lot.id);
          return lotValue && lotValue.value ? lotValue.value.amount : Infinity;
        });
      });
      return winners;
    },
    reverseContinuousAntiSnipingText() {
      const { antisniping } = this.auction || {};
      const { extensionPeriod } = antisniping || {};
      if (!extensionPeriod) return '';
      return `${Math.round(Number(extensionPeriod) / 60)} min`;
    },
    auctionDetailFieldLabelsWithColon() {
      return Object.keys(this.auctionDetailFieldLabels).reduce((acc, key) => {
        acc[key] = `${this.auctionDetailFieldLabels[key]}:`;
        return acc;
      }, {});
    },
    isAnonymousBidder() {
      return Boolean(this.$route.query.invitation_token);
    },
    tableHeaders() {
      const headers = [
        {
          text: 'Description',
          align: 'left',
          sortable: true,
          value: 'description',
        },
        {
          text: 'Quantity',
          align: 'left',
          sortable: true,
          value: 'quantity',
        },
      ];
      if (this.auction.items && this.auction.items.some((item) => item.documentUrl)) {
        headers.push({
          text: 'Document',
          align: 'left',
          sortable: false,
          value: 'documentUrl',
        });
      }
      return headers;
    },
    invitationLink() {
      let token = this.auction.invitationToken;
      if (window.location.href.includes('invitation_token')) {
        return window.location.href;
      } else {
        return window.location + '?invitation_token=' + token;
      }
    },
  },
  created() {
    this.getAuctionDetail();
  },
  methods: {
    ...mapActions(['setLoading', 'showSnackbar', 'inspectToken']),
    isTenderingOrAuctionStatus,
    formatCurrencyAmount,
    getAuctionDetail() {
      this.setLoading({ show: true, text: 'Loading...' });
      let context = { isAnonymous: this.isAnonymousBidder };

      this.inspectToken(context).then(() => {
        AuctionsService.getAuctionDetail(this.id, this.$route.query.invitation_token)
          .then((response) => {
            this.auction = response.data;
            this.setLoading({ show: false, text: '' });
            if (this.auction.auctionPeriod && this.auction.auctionPeriod.startDate) {
              this.timerStartDate(
                this.auction.auctionPeriod.startDate,
                'auctionStartDateTimer',
                'auctionStartDateInterval'
              );
            }
          })
          .catch((error) => {
            this.setLoading({ show: false, text: '' });
            console.log(error);
          });
      });
    },
    saveNewAucInfo() {
      let params = {};
      if (this.copyAuction.title !== this.auction.title) {
        params.title = this.copyAuction.title;
      }
      if (this.copyAuction.description !== this.auction.description) {
        params.description = this.copyAuction.description;
      }
      if (Object.entries({}).length === 0) {
        this.editAuction = false;
      }
      if (params.title || params.description || params.description === '') {
        this.setLoading({ show: true, text: 'Editing...' });
        AuctionsService.editAuction(this.auction.id, params)
          .then((response) => {
            this.editAuction = false;
            this.auction = response.data;
            this.setLoading({ show: false, text: '' });
          })
          .catch((error) => {
            this.setLoading({ show: false, text: '' });
            this.showSnackbar(error.response.data);
            this.getAuctionDetail();
          });
      }
    },
    timerStartDate: function (time, element, interval) {
      let vm = this;
      var countDownDate = new Date(time).getTime();
      this[interval] = setInterval(function () {
        // Get todays date and time
        var now = new Date().getTime();

        // Find the distance between now and the count down date
        var distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        var hours = Math.floor(distance / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        var renderedHours = hours.toString().length === 1 ? `0${hours}` : hours;
        var renderedMinutes = minutes.toString().length === 1 ? `0${minutes}` : minutes;
        var renderedSeconds = seconds.toString().length === 1 ? `0${seconds}` : seconds;

        vm[element] = `${renderedHours}:${renderedMinutes}:${renderedSeconds}`;
        if (distance < 0) {
          clearInterval(vm[interval]);
          vm[element] = 'Passed';
        }
      }, 1000);
    },
    copyToClipboard(data) {
      copyWithSnackbar({
        copyText: (text) => this.$copyText(text),
        showSnackbar: this.showSnackbar,
        text: data,
      });
    },
    closeWidgetDialog() {
      this.dialogWidget = false;
    },
    onCopy() {
      this.snackbar = true;
    },
    widgetApi(id) {
      let auctionStartDate;
      this.setLoading({ show: true, text: 'Loading...' });
      axios.get(this.apiAtreus + id, true).then((request) => {
        var vm = this;
        if (request.status >= 200 && request.status < 400) {
          if (!request.data.data.status.indexOf('active')) {
            if (request.data.data.auctionPeriod.startDate) {
              auctionStartDate = request.data.data.auctionPeriod.startDate;
            }
            vm.setLoading({ show: false, text: '' });
            var deadline = new Date(auctionStartDate).getTime();
            this.timer = setInterval(function () {
              var now = new Date().getTime();
              vm.widgetRequest = true;
              var t = deadline - now;
              if (t < 0) {
                vm.widgetTitle =
                  AUCTION_DETAIL_TITLE_LABELS.WIDGET_STATUS_PREFIX +
                  vm.auctionStatusByKey[request.data.data.status];
                clearInterval(vm.timer);
              } else {
                var days = Math.floor(t / (1000 * 60 * 60 * 24));
                var hours = Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                var minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((t % (1000 * 60)) / 1000);
                vm.countDown.day = days;
                vm.countDown.hour = hours;
                vm.countDown.minute = minutes;
                vm.countDown.second = seconds;
              }
            }, 1000);
          } else {
            this.widgetRequest = true;
            this.setLoading({ show: false, text: '' });
            this.widgetTitle =
              AUCTION_DETAIL_TITLE_LABELS.WIDGET_STATUS_PREFIX +
              this.auctionStatusByKey[request.data.data.status];
          }
        }
      });
    },
    getStatusClass(status) {
      return getAuctionStatusClass(status, '');
    },
    getStatusColor(status) {
      return getAuctionStatusColor(status);
    },
    succesCopyToClipboard() {
      this.showSnackbar('COPIED');
    },
    getCurrencySymbol(currency) {
      return utils.getCurrencySymbol(currency);
    },
    copyClipboard() {
      if (this.auction.related_id) {
        let scriptJs = `${window.location.origin}/widget.js`;
        return (
          '<div id="atreus-auction-info" data-auction-id="' +
          this.auction.related_id +
          '" id="atreus-auction-info" data-auction-invitation-link="' +
          this.invitationLink +
          '" data-auction-api-atreus="' +
          this.apiAtreus +
          '" data=' +
          JSON.stringify({
            backgroundColorForWidget: this.backgroundColorForWidget,
            backgroundForTiming: this.backgroundForTiming,
            headerTitleColor: this.headerTitleColor,
            zoomBlock: this.zoomBlock,
            buttonColor: this.buttonColor,
          }) +
          '></div>\n' +
          '<script async type="text/javascript" src="' +
          scriptJs +
          '">' +
          '</scr' +
          'ipt>'
        );
      }
      return '';
    },
  },
  validations() {
    return {
      form: {
        name: {
          required,
          minLength: minLength(2),
        },
        email: {
          required,
          email,
        },
        bid: {
          required,
          minValue:
            this.auction &&
            this.auction.value &&
            this.auction.procurementMethodType === ENGLISH_TYPE
              ? minValue(this.auction.value.amount)
              : 1,
          maxValue:
            this.auction &&
            this.auction.value &&
            isReverseLikeType(this.auction.procurementMethodType)
              ? maxValue(this.auction.value.amount)
              : false,
        },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.auc-info {
  position: relative;
  padding: 0;
  display: block;
  width: 55%;
  min-width: 900px;
  margin: 80px auto 32px auto;
  justify-content: space-between;
  flex-direction: row;
  background: #ffffff;
  padding-bottom: 20px;
  .auc-logo {
    width: 252px;
    height: 202px;
  }
  img {
    text-align: center;
    vertical-align: middle;
    line-height: 202px;
  }
  .edit-auc-cancel,
  .edit-auc-save {
    display: flex;
    align-items: center;
  }
  .edit-auc-cancel {
    color: #ef9a9a;
    caret-color: #ef9a9a;
  }
  .edit-auc-save,
  .edit-auc-cancel {
    &:hover {
      opacity: 0.8;
    }
  }
  .edit-auc {
    color: #2e7f89;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    position: absolute;
    top: -26px;
    right: 0;
    font-weight: 500;
    .material-icons {
      margin-left: 6px;
    }
    &:hover {
      opacity: 0.8;
    }
  }
  .edit-auc-cancel-save {
    &:hover {
      opacity: 1;
    }
  }
}

.widget--amount,
.widget--amount strong {
  font-size: 30px;
}

.widget--amount {
  margin-left: 20px;
  text-align: left;
}

div#clockdiv div {
  margin-left: 4px;
}
h1 {
  color: #396;
  font-weight: 100;
  font-size: 40px;
  margin: 20px 0px 20px;
}
#clockdiv {
  font-family: sans-serif;
  color: #fff;
  display: flex;
  font-weight: 100;
  text-align: center;
  font-size: 20px;
  flex-wrap: wrap;
  margin-left: 20px;
}
.auc-status,
.auc-type {
  border-radius: 8px;
  padding: 1px 7px;
  color: #000000;
}
#clockdiv > div {
  padding: 5px;
  border-radius: 3px;
  background: #00bf96;
  display: inline-block;
}
#clockdiv div > span {
  padding: 15px;
  border-radius: 3px;
  display: inline-block;
}
.flex-row {
  margin-top: 40px !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: space-between !important;
}
.widget {
  position: fixed;
  bottom: 8px;
  right: 8px;
  background: #007781 !important;
}

.button {
  text-decoration: none;
  text-align: center;
  color: #fff;
  width: 50%;
  margin-top: 20px;
  margin-left: 20px;
  font-size: 25px;
  cursor: pointer;
  margin-bottom: 20px;
}

div strong {
  font-size: 12px;
}
.align-start {
  align-items: start;
}
.invite {
  min-width: 900px;
  width: 55%;
  text-align: right;
  margin: 0 auto;
}
.label-heading {
  display: block;
  border-left: 5px solid #2e7f89;
  box-sizing: border-box;
  margin-left: -18px;
  padding-left: 14px;
}
h3 {
  text-align: left;
  color: #2e7f89;
  margin-top: 36px;
}
.v-timeline {
  margin-bottom: -56px;
}
.right-side {
  
  text-align: left;
  padding: 27px 34px;
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  height: 100%;

  .auc-title {
    
    font-size: 30px;
    font-weight: 600;
    color: #2e7f89;
    margin-bottom: 25px;
  }
  .auc-discription {
    text-align: justify;
    width: 100%;
    font-size: 13px;
    font-weight: 400;
    line-height: 24px;
    margin-bottom: 25px;
  }
  .auc-price {
    
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 6px;
  }
  span {
    font-weight: 200;
    font-size: 12px;
  }
}
.auction-container {
  margin: auto;
}
.items-form {
  padding: 0;
  width: 100%;
  margin: 0 auto 9px auto;
}
.strong {
  
}
.timeLine-block {
  padding-right: 0;
}
.start-date {
  background: #2e7f89 !important;
}
.price-block {
  margin-right: 40px;
}
.data-table td {
  text-align: left !important;
}
.tbl-row {
  width: 100%;
  text-align: left;
}
.tbl-row-rewerse {
  text-align: right;
}
.flex-center {
  display: flex;
  overflow: hidden;
}
.material-icons:hover {
  color: #2e7f89;
}
.form .card-text {
  padding: 6px 16px;
}
.card-text {
  padding: 12px 16px;
}
.custom-input-edit {
  line-height: 1.6rem;
  background: rgba(169, 169, 169, 0.2);
  padding: 0 0 0 6px;
  border: 2px solid rgb(46, 127, 137);
}
.custom-input {
  height: 42px;
  margin-bottom: 0;
  width: 100%;
}
.copy {
  cursor: pointer;
}
.detail-auction__right-side {
  margin-top: 10%;
}

@media (max-width: 1000px) {
  .v-timeline {
    margin-bottom: 0;
  }
  img {
    margin-left: 34px;
  }
  .anonymous-container {
    display: flex;
    flex-direction: column;
  }

  .auc-info.activeTendering {
    display: flex;
    order: 1;
    margin: -20px auto 10px auto;
  }
  .auc-info {
    flex-direction: column;
    min-width: 90%;
  }
  .detail-auction__right-side {
    text-align: left;
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: start;
    justify-content: start;
    height: 100%;
    margin-top: 0;
  }
}
</style>
